import classNames from 'classnames/bind';
import { SelectAirportContext } from 'common/autocomplete/SelectAirportContext';
import {
  IAirport,
  ICity,
  LocationType,
  TLocation,
} from 'common/autocomplete/types';
import { useContext, useState } from 'react';
import Airport from './Airport';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  city: ICity;
  forDeparture: boolean;
  locations: TLocation[];
  markMatchedSubstrings(target: string): { __html: string };
}

const City = ({
  city,
  forDeparture,
  locations,
  markMatchedSubstrings,
}: IProps) => {
  const {
    cityName,
    cityNameEn,
    countryName,
    countryNameEn,
    event,
    iataCode,
    isDomestic,
    type,
  } = city;

  const handleClick = useContext(SelectAirportContext);
  const [isExpanded, setIsExpanded] = useState(true);

  const subAirports = locations.filter(
    location =>
      location?.type === LocationType.AIRPORT &&
      location?.airportName &&
      location?.airportNameEn &&
      location?.cityCode === iataCode,
  );

  return (
    <li className={cx('list_item')}>
      <div className={cx('list_item_inner')}>
        <div
          className={cx('anchor', subAirports?.length > 0 && 'has_child', {
            is_expanded: isExpanded,
          })}
          data-event-nlog="click"
          data-event-area-code={`${forDeparture ? 'dep' : 'arr'}.autocity`}
          onClick={() =>
            handleClick({
              code: iataCode,
              name: cityName,
              isDomestic,
              cityCode: iataCode,
            })
          }
        >
          <i className={cx('icon')} data-type={type.toUpperCase()} />
          <b className={cx('name')}>
            <span
              className={cx('name_inner')}
              dangerouslySetInnerHTML={markMatchedSubstrings(cityName)}
            />
            {', '}
            <span
              className={cx('name_inner')}
              dangerouslySetInnerHTML={markMatchedSubstrings(countryName)}
            />
            &nbsp;
            <span
              className={cx('en')}
              dangerouslySetInnerHTML={markMatchedSubstrings(iataCode)}
            />
          </b>
          <div className={cx('desc')}>모든 공항</div>
        </div>
        {subAirports?.length > 0 && (
          <button
            className={cx('btn_expand')}
            data-event-nlog="click"
            data-event-area-code={`${forDeparture ? 'dep' : 'arr'}.autocitymore`}
            type="button"
            onClick={() => setIsExpanded(prev => !prev)}
            aria-expanded={isExpanded}
          />
        )}
      </div>
      {isExpanded && subAirports?.length > 0 && (
        <ul className={cx('airport_list')}>
          {subAirports.map(airport => (
            <Airport
              airport={airport as IAirport}
              forDeparture={forDeparture}
              markMatchedSubstrings={markMatchedSubstrings}
              isSubAirport
              key={(airport as IAirport)?.iataCode}
            />
          ))}
        </ul>
      )}
    </li>
  );
};

export default City;
